module.exports = __webpack_public_path__ + "img/edge_divers_pin.27685986.svg";